import { c as _c } from "react/compiler-runtime";
import { useOrgUrlSync } from "@/hooks/useConnectedGithubOrgs";
import { ReactNode } from "react";
interface OrgUrlSyncProviderProps {
  children: ReactNode;
}

// This component wraps pages that need URL-based org sync
// It should only be used on pages that have [org] in their route
export function OrgUrlSyncProvider(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  useOrgUrlSync();
  let t1;
  if ($[0] !== children) {
    t1 = <>{children}</>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}